import { OptionDescriptionModalTranslation, RequestQuoteContentTranslation, SiteTranslation } from './SiteTranslation';

// tslint:disable:max-line-length

const requestQuoteDefaultTranslation: RequestQuoteContentTranslation = {
  confirmation: {
    pageDescriptionFormat: 'Opis',
    pageTitleFormat: 'Potwierdzenie',
    buttonLink: 'Kontynuuj zakupy',
    title: 'Dziękujemy! Twoja prośba o wycenę jest juz w drodze.',
    content: 'Nasz lokalny sprzedawca wkrótce skontaktuje się z Tobą',
  },
  goBackLink: 'Wróć',
  title: 'Zapytaj o cenę',
  stepsTitle: 'Co się stanie z moim zapytaniem?',
  steps: [
    'Twoja prośba o wycenę zostanie przesłana do lokalnego sprzedawcy',
    'Nasz sprzedawca przygotuje ofertę dla Ciebie',
    'Nasz sprzedawca skontatkuje się z Tobą',
  ],
};

const requestQuoteProcessedByDealerTranslation: RequestQuoteContentTranslation = {
  ...requestQuoteDefaultTranslation,
  confirmation: {
    ...requestQuoteDefaultTranslation.confirmation,
    content: 'Nasz lokalny sprzedawca wkrótce skontaktuje się z Tobą',
  },
  steps: [
    'Twoja prośba o wycenę zostanie przesłana do lokalnego sprzedawcy',
    'Nasz sprzedawca przygotuje ofertę dla Ciebie',
    'Nasz sprzedawca skontatkuje się z Tobą',
  ],
};

const optionDescriptionModal: OptionDescriptionModalTranslation = {
  closeButton:
    'Zamknij',
};

const translation: SiteTranslation = {
  layout: {
    topBar: {
      title: 'Flokk',
      chooseChairLink: 'Wybierz krzesła',
      aboutUsLink: 'O nas',
      inputSearchPlaceholder: 'Szukaj',
      languages: {
        chDe: 'Niemiecki',
        chFr: 'Francuski',
        deDe: 'Niemiecki',
        dkDk: 'Duński',
        enUs: 'Angielski',
        frFr: 'Francuski',
        nlNl: 'Holenderski',
        nbNo: 'Norweski',
        enGB: 'Angielski',
        svSe: 'Szwedzki',
        plPl: 'Polski',
      },
    },
    footerPanel: {
      emailLabel: 'e-mail: ',
      phoneLabel: 'tel: ',
      countactUsLink: 'Kontant z lokalnym oddziałem',
      followUsLabel: 'Śledź nas!',
      copyright: 'Copyright',
      allRightReserved: 'Wszystkie prawa zastrzerzone',
    },
    titleFormat: '{title} - Flokk - Skonfiguruj swoje krzesło',
  },
  requestQuotePage: {
    errorMessage: 'Wystąpił błąd podczas ładowania formularza. Skontaktuj się z obsługą klienta.',
    pageDescriptionFormat: 'Opis',
    pageTitleFormat: 'Zapytaj o cenę',
    defaultContent: requestQuoteDefaultTranslation,
    contentWhenProcessedByDealer: requestQuoteProcessedByDealerTranslation,
  },
  emailMyConfigurationPage: {
    errorMessage: 'Wystąpił błąd podczas ładowania formularza. Skontaktuj się z obsługą klienta.',
    pageDescriptionFormat: 'Opis',
    pageTitleFormat: 'Wyślij mi moją konfigurację na mój e-mail',
    confirmation: {
      pageDescriptionFormat: 'Opis',
      pageTitleFormat: 'Wyślij mi moją konfigurację na mój e-mail',
      buttonLink: 'Wróć do strony głównej',
      title: 'Dziękujemy! Wiadomość e-mail już jest w drodze.',
      content: 'Sprawdź skrzynkę pocztową.',
    },
    goBackLink: 'Wróć do konfiguratora',
    title: 'Wyślij mi moją konfigurację na mój e-mail',
  },
  homePage: {
    pageDescriptionFormat: 'Opis',
    pageTitleFormat: 'Strona główna',
    articleList: {
      readMore: 'Dowiedz się więcej',
    },
    productList: {
      fromPriceLabel: 'OD {price} z VAT',
      productThumbnail: {
        productVariationList: {
          title: 'Warianty'
        }
      }
    },
  },
  configurationSearchPage: {
    pageDescriptionFormat: 'Opis',
    pageTitleFormat: 'Znajdź konfigurację',
    title: 'Wpisz kod swojej konfiguracji',
    description: 'i zostaniesz przeniosiony do konfiguratora.',
    codeInputPlaceholder: 'Wpisz kod tutaj i naciśnij Enter.',
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Kod powinien mieć dokładnie {expectedLength} znaków.',
      codeInvalid: 'Podany kod {invalidCode} jest nieprawidłowy! Upewnij się, że został wpisany poprawnie.',
      codeNotFound: 'Nie jesteśmy w stanie znaleźć konfiguracji o kodzie {notFoundCode}.',
    },
  },
  configurationDetailsPage: {
    pageTitleFormat: '{code} - Szczegóły konfiguracji',
    pageDescriptionFormat: '{productName} {options} {accessories}',
    title: 'Twoja wybrana konfiguracja',
    visualizationNotAvailableText: 'Wizualizacja niedostępna',
    configurationInvalidOrObsolete: 'Konfiguracja jest niekompletna lub przestarzała, przed zakupem skonfiguruj ponownie.',
    unableToValidateConfigurationCode: 'Wystąpił problem przy weryfikacji konfiguracji i możliwość zakupu została wyłączona, proszę spróbować później lub skontaktować się z obsługą klienta.'
  },
  confirmationPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Potwierdzenie zamówienia',
    title: 'Gratulacje!',
    errorTitle: 'Wystąpił błąd',
    paymentConfirmed: 'Płatnoś została zaakceptowana.',
    checkYourEmail: 'Szczegóły Twojego zamówienia zostały wysłane na adres email.',
    errorContent: 'Wystąpił błąd, skontaktuj się z działem obsługi klienta.',
    orderSection: {
      title: 'Twoje zamówienie',
      orderNumber: 'Numer zamówienia',
    },
    summarySection: {
      title: 'Podsumowanie',
      taxText: '+ VAT',
      totalToPayText: 'Do zapłaty',
      contact: {
        contactAndBilling: 'Dane kontaktowe',
        deliveryAddress: 'Adres dostawy',
      },
    },
    designerSectionTitle: 'Czy wiesz, kto zaprojektował Twoje krzesło?',
    customerStorySectionTitle: 'Poznaj naszych klientów',
    readMore: 'Dowiedz się więcej',
    contactUsSection: {
      text: 'W razie pytań skontaktuj się z',
      linkText: 'działem obsługi klienta',
    },
  },
  checkoutPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Zrealizuj zamówienie',
    title: 'Zrealizuj zamówienie',
    goBackLink: 'Wróć',
    progress: {
      title: 'Zrealizuj zamówienie',
      deliveryStep: 'Dane kontaktowe i dostawa',
      paymentStep: 'Płatność',
      confirmationStep: 'Potwierdzenie',
    },
    goToPaymentButton: '*Potwierdź i zapłać za pomocą',
    paymentMethodLabel: '*Wybierz metodę płatności',
    orderAndPayButton: 'Zamów i zapłać',
    submitButton: 'Wyślij',
    paymentPoweredByText: 'Płatności przetwarzane są przez',
    addressForm: {
      city: {
        name: 'Miasto',
        placeholder: '',
        fieldRequired: 'Miasto jest wymagane',
      },
      country: {
        name: 'Kraj',
        placeholder: 'Wprowadź kraj',
        fieldRequired: 'Kray jest wymagany',
      },
      street: {
        name: 'Ulica',
        placeholder: 'Wprowadź ulicę',
        fieldRequired: 'Ulica jest wymagana',
      },
      streetNumber: {
        name: 'Numer lokalu',
        placeholder: 'Wprowadź numer lokalu',
        fieldRequired: 'Numer lokalu',
      },
      zipCode: {
        name: 'Kod pocztowy',
        fieldRequired: 'Kod pocztowy jest wymagany',
        wrongFormat: 'Wprowadzony kod jest niepoprawny',
      },
      availableCountries: {
        POL: 'Polska',
        NOR: 'Norwegia',
        CHE: 'Szwajcaria',
        DEU: 'Niemcy',
        DNK: 'Dania',
        FRA: 'Francja',
        NLD: 'Holandia',
        SWE: 'Szwecja',
        GBR: 'Wielka Brytania',
        USA: 'Stany Zjednoczone',
      },
      addressLine1: {
        name: 'Adres',
        placeholder: '',
        fieldRequired: 'Adres jest wymagany',
        wrongFormat: '',
      },
      addressLine2: {
        name: 'Adres 2 (opcjonalnie)',
        placeholder: '',
        fieldRequired: '',
        wrongFormat: '',
      },
      recipient: {
        name: 'Odbiorca',
        placeholder: '',
        fieldRequired: 'Odbiorca jest wymagany',
        wrongFormat: '',
      },
    },
    contactForm: {
      contactDetails: 'Dane kontaktowe',
      email: {
        name: 'Email',
        placeholder: '',
        fieldRequired: 'Email jest wymagany',
        wrongFormat: 'Wprowadzony email jest niepoprawny',
      },
      phone: {
        name: 'Numer telefonu',
        placeholder: '',
        fieldRequired: 'Numer telefonu jest wymagany',
        wrongFormat: '*Wprowadzony numer telefonu jest nieprawidłowy',
      },
      phonePrefix: {
        name: 'Numer kierunkowy',
        placeholder: '+ _ _',
        fieldRequired: 'Prefix jest wymagany',
        wrongFormat: '*Wprowadzony prefix jest nieprawidłowy',
      },
      firstName: {
        name: 'Imię',
        placeholder: '',
        fieldRequired: 'Imię jest wymagane',
      },
      lastName: {
        name: 'Nazwisko',
        placeholder: '',
        fieldRequired: 'Nazwisko jest wymagane',
      },
      companyName: {
        name: 'Nazwa firmy (opcjonalnie)',
        placeholder: '',
      },
      taxId: {
        name: 'Identyfikator podatkowy firmy (NIP)',
        placeholder: '',
        fieldRequired: 'Identyfikator podatkowy firmy jest wymagany',
      },
    },
    shippingMethodSection: {
      subtitle: 'Sposób dostawa',
      shippingMethod: {
        name: 'Sposób dostawy',
        fieldRequired: 'Wybranie sposobu dostawy jest wymagane',
      },
    },
    deliveryAddressSection: {
      subtitle: 'Adres dostawy',
      billingAndDeliveryAreTheSameText: 'Adres dostawy i adres do faktury są takie same ',
      deliveryInfoText: 'Darmowa dostawa w ciągu 10 do 15 dni',
    },
    paymentMethods: {
      supportedCreditCardsMessage: {
        acceptedCreditCardsText: 'Akceptujemy następujące karty kredytowe',
      },
      klarna: {
        selectPaymentCategory: `Proszę wybierz kategorię płatności:`
      }
    },
    readyToOrderSection: {
      subtitle: 'Gotowy na zamówienie?',
      termsAndConditions: {
        termsAndConditionLinkName: 'Regulamin sklepu',
        name: 'Akceptuje warunki',
        placeholder: '',
        fieldRequired: 'To pole jest wymagane',
      },
      subscription: 'Chciałbym otrzymać dodatkowe...',
    },
    readyToOrderPaymentSection: {
      subtitle: 'Gotowy na zamówienie?',
    },
    errors: {
      creatingOrderFailed: 'Nie możemy złożyć zamówienia. Spróbuj ponownie lub skontaktuj się z obsługą klienta.',
      initializingPaymentFailed:
        'Nie możemy przetworzyć płatności. Spróbuj ponownie lub skontaktuj się z obsługą klienta.',
      authorizingPaymentFailed: 'Nastąpił błąd autoryzacji. Spróbuj ponownie lub skontaktuj się z obsługą klienta.',
      finalizingPaymentFailed:
        'Nie możemy sfinalizować płatności. Spróbuj ponownie lub skontaktuj się z obsługą klienta.',
    },
    discountCodeForm: {
      applyButton: 'Zastosuj',
      discountCodeIsAppliedMessage: 'Kod promocyjny "{code}" jest aktywny.',
      discountCodeIsInvalidOrExpiredError: 'Podany kod rabatowy jest niepoprawny lub nie jest już dostępny.',
      doYouHaveDiscountCodeText: 'Czy posiadasz kod rabatowy?',
      enterCodeText: 'Wpisz kod',
      label: 'Kod rabatowy',
    },
  },
  checkoutShortcutPage: {
    pageTitleFormat:
      'Zrealizuj zamówienie',
    pageDescriptionFormat:
      '',
    errors: {
      addingProductToCartFailed:
        'Nie można zakupić produktu z kodem {code}. Proszę skontaktuje się z działem obsługi klienta.',
      gettingProductConfigurationFailed:
        'Nie można pobrać informacji o produkcie z kodem {code}. Proszę odśwież stronę lub skontaktuj się z działem klienta.',
    }
  },
  configurationPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Konfigurator',
    productDetails: {
      documentsSection: 'Dokumenty',
      moreInformationSection: 'Więcej informacji',
      specificationSection: 'Specyfikacja',
    },
    showFiltersText: 'Pokaż filtry',
    hideFiltersText: 'Ukryj filtry',
    productModels: {
      chooseModelText: 'Wybierz swój model',
      modelSelectorWithLoader: {
        noOtherModelsAvailable: 'Przepraszamy, inne modele nie są dostępne.',
      },
    },
    options: {
      title: 'Dostosuj swoje krzesło',
      priceGroup: 'Grupa cenowa',
      textSelected: 'Wybrano',
      fabricFilters: {
        noFabricsAvailable: 'Nie ma materiałów pasujących do Twoich wyborów.',
        clearButton: 'Wyczyść',
        defaultFilterName: 'Wszystkie',
        collectionFilterLabel: 'Kolekcja'
      },
    },
    accessories: {
      title: 'Akcesoria',
      accessory: {
        removeButton: 'Usuń',
        addButton: 'Dodaj',
        textSelected: 'Wybrano',
      },
    },
    summary: {
      title: 'Podsumowanie konfiguracji',
      accessoriesSubtitle: 'Akcesoria',
      requestQuoteButton: 'Zapytaj o wycenę',
      emailConfirmationButton: 'Wyślik konfigurację na maila',
      limitedChairQuantity: 'Aby zamówić więcej niż {max} krzesła skontaktuj się z działem obsługi klienta',
      checkoutButton: 'Zamów',
      editConfigurationLink: 'Edytuj',
      expectedShipment: {
        expectedShipment: 'Przewidywana wysyłka',
        days: 'dni',
      },
      quantityInput: {
        outOfRangeWarning: 'Wartość musi być pomiędzy {min} a {max}',
      },
      saveYourConfigurationHereButton: 'Zapisz swoją konfigurację.',
      backButton: 'Wróć do konfiguratora',
      shareSection: {
        title: 'Zapisz swoją konfigurację',
        yourConfigurationUrl: 'URL konfiguracji',
        downloadAsPdf: 'Pobierz jako PDF',
        downloadVisualizations: 'Pobierz wizualizacje',
        codeShare: {
          codeTitle: 'Kod konfiguracji',
          copyCode: {
            label: 'Skopiuj kod',
            textCopiedLabel: 'Skopiowano!',
          },
        },
        copyLink: {
          label: 'Skopiuj link',
          textCopiedLabel: 'Skopiowano!',
        },
        closeButton: 'Zamknij',
      },
      findLocalDealerSection: {
        title: 'Gdzie jest Flokk?',
        button: 'Znajdź lokalnych sprzedawców',
      },
    },
    restrictions: {
      accessorySelection: {
        header: {
          userSelectionNotRequiredFormat: 'Jesteś pewien że chcesz dodać {itemName} jako akcesorium?',
          userSelectionRequiredFormat: 'Jeżeli chcesz dodać {itemName} musisz zmienić inne wybory.',
        },
        automaticDeselectionOfAccessoriesFormat:
          'Wybrane akcesorium nie jest dostępne z {itemsToDeselect}. Jeżeli wybierzesz to akcesorium to akcesoria poniżej zostaną odznaczone.',
      },
      optionSelection: {
        header: {
          userSelectionNotRequiredFormat: `Czy jesteś pewny, że chcesz zmienić opcję {itemName}?`,
          userSelectionRequiredFormat: `Jeżeli chcesz zmienić {itemName} musisz zmienić inne wybory`,
        },
        automaticDeselectionOfAccessoriesFormat:
          'Wybrana opcja nie jest dostępna z {itemsToDeselect}. Jeżeli wybierzesz tą opcję to podane opcje to akcesoria poniżej zostaną odznaczone.',
      },
      itemNotAvailableWithFormat: '{itemToSelect} nie jest dostępny z {itemsToDeselect}.',
      itemsSeparator: ' i ',
      selectMatchingOption: ' Poniżej możesz zobaczyć dostępne opcje.',
      cancelButton: 'Anuluj',
      applyButton: 'Zgadzam się, zmień',
      closeButton: 'Zamknij',
      selectedText: 'Wybrany',
    },
    tabs: {
      fabrics: {
        name: 'Materiały',
      },
      options: {
        name: 'Opcje',
      },
      accessories: {
        name: 'Akcesoria',
      },
      summary: {
        name: 'Podsumowanie',
      },
    },
    productNotAvailableInCurrentStoreWarning: {
      messageFormat:
        'Przepraszamy, ale w tej chwili nie możemy wyświetlić tego produktu. W razie pytań prosimy o kontakt z naszym działem obsługi klienta pod adresem info@flokk.com.',
    },
    productInactiveWarning: {
      discontinued: '*This is a discontinued product',
      generic: '*Product is not available',
      genericWithReason: '*Product is not available: {reason}'
    },
    obsoleteCodeModal: {
      notAvailable: {
        title: 'Konfiguracja krzesła nie jest dostępna',
        intro: 'Podana konfiguracja produktu nie jest już dostępna.',
        introWithCodePart1: 'Podana konfiguracja produktu o kodzie',
        introWithCodePart2: 'nie jest już dostępna.',
        explanation: 'Następujące części lub materiały nie mogą być użyte:',
      },
      restricted: {
        title: 'Konfiguracja krzesła nie jest poprawna',
        intro: 'Podana konfiguracja produktu nie jest poprawna.',
        introWithCodePart1: 'Podana konfiguracja produktu o kodzie',
        introWithCodePart2: 'nie jest poprawna.',
        explanation: 'To może być spowodowane przez zmiany w budowie produktu.',
      },
      footer: 'Proszę skonfiguruj swoje krzesło jeszcze raz.',
      closeButton: 'Zamknij',
    },
    optionDescriptionModal,
    metaTitleFormat: 'Mój {productName}',
    metaDescriptionFormat: '{productName}: {options}',
    priceTaxText: 'brutto',
  },
  modularConfiguratorPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Konfigurator',
  },
  storeAndLanguageSelector: {
    title: 'Wybierz swój kraj lub język',
    storeSelectorLabel: 'Kraj',
    languageSelectorLabel: 'Język',
  },
  initialStoreSelectorModal: {
    title: 'Cześć',
    description: 'Wybierz swój kraj lub przejdź do strony międzynarodowej',
    buttonContinue: 'Kontynuuj',
    inputPlaceholder: 'Wybierz swój kraj',
    languageInputPlaceholder: 'Wybierz język',
    linkLabelInternationalStore: 'Przejdź do strony międzynarodowej',
    noOptionMessage: 'Kraj nie został znaleziony',
    noLanguageMessage: 'Język nie został znaleziony',
  },
  noConnectionModal: {
    title: 'O nie!',
    content: 'Utracono połączenie z internetem',
    continueLink: 'Kontynuuj',
    buttonSeparator: 'lub',
    refreshButton: 'Odśwież stronę',
    closeButton: 'Zamknij',
  },
  emptyCartPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Koszyk jest pusty',
    basketEmptyLine1: 'Twój koszyk jest pusty',
    basketEmptyLine2: 'ale nie musi taki być.',
    continueButton: 'Kontynuuj zakupy',
  },
  pageNotFound: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Nie znaleziono strony',
    content: 'Nie możemy znaleźć strony której szukasz',
    title: 'O nie!',
    buttonLink: 'Przejdź do strony głównej',
  },
  generalErrorPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Wystąpił błąd',
    title: 'Wystąpił błąd!',
    content: 'Prosimy spróbować ponownie później',
    buttonLink: 'Spróbuj ponownie',
  },
  invalidCodePage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Błędny kod konfiguracji',
    title: 'Blędny kod konfiguracji',
    content: 'Wprowadź poprawny kod',
    buttonLink: 'Wróć do Flokk',
  },
  productSpecificationPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Specyfikacja produktu',
    accessoriesSection: 'Akcesoria',
    linkTitle: 'Twój link konfiguracyjny',
    codeTitle: 'Twój kod konfiguracyjny',
    pricesSection: {
      unitPrice: 'Cena za jednostkę',
      quantity: 'Ilość',
      subtotalPrice: 'Częściowa cena',
    },
    dataSection: {
      title: 'Dane',
      brand: 'Marka',
      code: 'Kod artykułu',
    },
  },
  storeLocatorPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Znajdź sklepy, wystawy i biura Flokk',
    heading: 'Znajdź swój sklep',
    storeSearch: {
      noDealersText: 'Przepraszamy, żaden sklep ani biuro nie są dostępne na tym obszarze.',
      noDealersWithFiltersText:
        'Przepraszamy, żaden sklep ani biuro nie są dostępne dla wybranych kryteriów wyszukiwania.',
      filterResultText: 'Znaleziono {storesNumber} sklepów',
      storeLocatorInput: {
        label: 'Znajdź swój sklep',
        placeholder: 'Miasto, województwo lub kod pocztowy',
        orText: 'lub',
        currentLocationText: 'użyj bieżącej lokalizacji',
        disabledGeolocationText: 'Geolokalizacja jest wyłączona.',
        unavailableGeolocationText: 'Geolokalizacja jest niedostępna.',
        tryAgainText: 'Spróbuj ponownie.',
      },
      storeLocatorFilters: {
        title: 'Filtry',
        placesLabel: 'Typy punktów',
        brandLabel: 'Marka',
      },
    },
    storeTypes: {
      Showroom: 'Salon wystawowy',
      Shop: 'Sklep',
    },
    details: {
      webSite: 'Strona internetowa',
      address: 'Adres',
      directionLink: 'Jak dojadę',
      email: 'Email',
      openHours: 'Godziny otwarcia',
      phone: 'Telefon',
      closeButton: 'Zamknij',
      backButton: 'Wróć do listy',
    },
  },
  cart: {
    summary: {
      deliveryFee: 'Koszt dostawy',
      subTotal: 'Cena bez VAT',
      totalTaxFormat: 'VAT ({taxTotal}%)',
      subTotalWithTax: 'Cena z VAT',
      totalToPay: 'Do zapłaty',
      moreInformationText: 'Więcej informacji',
      lessInformationText: 'Mniej informacji',
      quantityText: 'Ilość',
      shippingTimeText: {
        deliveredWithin: 'Wysyłka w ciągu',
        day: 'dzień',
        days: 'dnia',
        week: 'tygodnia',
        weeks: 'tygodni',
      },
      configurationCodeLabel: 'Kod',
      deliveryCostUnavailable: 'Wybierz metodę dostawy',
      freeDeliveryText: 'Darmowa dostawa do domu',
      taxText: '+ VAT',
      discount: 'Rabat',
      surcharges: {
        'eco-tax': 'Eco podatek',
      }
    },
  },
  redirectionWarningModal: {
    closeButton: 'Zamknij',
    title: 'Zostaniesz automatycznie przekierowany za kilka sekund. Rusz myszką lub dotknij ekranu aby anulować.',
  },
  scrollToTop: {
    button: 'Do góry',
  },
  productFamilyPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: '',
    overviewSection: {
      name: 'Podsumowanie',
    },
    designerSection: {
      name: 'Projektant',
      designedBy: 'Zaprojektowane przez',
      readMore: 'Dowiedz się więcej',
    },
    relatedProducts: {
      name: 'Podobne produkty',
      title: 'A może zainteresują Cię podobne produkty',
    },
    productUserStories: {
      name: 'Projekty',
      readMore: 'Dowiedz się więcej',
      title: 'Projekt',
    },
    modelsSection: {
      name: 'Modele',
      productInfo: {
        priceSection: {
          taxText: 'brutto',
          fromText: 'od',
        },
        popularDesigns: {
          title: 'Popularne projekty',
        },
        actions: {
          configureChairButton: 'Skonfiguruj',
          askForPriceButton: 'Zapytaj o cenę',
          goToCheckoutButton: 'Zamów',
          whereToBuyButton: 'Gdzie kupić',
        },
        whereToBuy: {
          text: 'Sprzedajemy nasze produkty poprzez sieć autoryzowanych partnerów.',
          designCustomChairText:
            ' Jeżeli jednak chcesz stworzyć własne krzesło, zaprojektuj je przy użyciu konfiguratora, a my je dla Ciebie wycenimy.',
        },
      },
      productModelSelector: {
        heading: 'Wybierz swój wariant',
      },
      modelViewer: {
        hint: 'Kliknij na obrazku, aby powiększyć',
      },
    },
    productModelDetailsSection: {
      assetsDownloader: {
        downloadAllButton: 'Ściągnij wszystko',
        other: 'Pozostałe',
        categories: {},
      },
      downloadsSectionTitle: 'Pliki do pobrania',
      environmentalDataSection: {
        averagedValuesDisclaimerText:
          'Wszystkie wartości są średnie dla tego modelu, dla niektórych produktów liczby mogą się różnić. Przedstawione wartości są oparte na dostępnych EPD dla każdego produktu, w standardzie +A1:2013 lub +A2:2019 i będą stale aktualizowane zgodnie z nowymi deklaracjami.',
        energyUsageMjText: 'Zużycie energii',
        co2EmissionKgText: 'Emisja dwutlenku węgla',
        recyclableMaterialsText: 'materiałów nadających się do recyklingu',
        recycledAluminiumText: 'Aluminium z recyklingu',
        recycledMaterialsTitle: 'Materiały pochodzące z recyklingu',
        recycledMaterialsText: 'materiałów z recyklingu',
        recycledPlasticText: 'Plastik z recyklingu',
        recyclableMaterialsTitle: 'Poziom recyklingu',
      },
      environmentalDataSectionTitle: 'Wpływ na środowisko',
      name: 'Szczegóły',
      specificationSectionTitle: 'Specyfikacja',
    },
    suggestedConfigurationsSection: {
      name: 'Popularne konfiguracje',
      title: 'Szukasz czegoś specjalnego?',
      subtitle: 'Możesz wybrac dowolny kolor, materiał, akcesorium i jeszcze więcej.',
      buttonText: 'Skonfiguruj',
    },
    gallerySection: {
      name: 'Galeria',
    },
    userGuideVideoSection: {
      name: '',
      videoTitle: 'Instrukcja użytkowania',
    },
  },
  viewerPage: {
    pageDescriptionFormat: '',
    pageTitleFormat: 'Przeglądarka',
  },
  zoomModal: {
    closeButton: 'Zamknij',
  },
  common: {
    chairVisualization: {
      zoomHintText: 'Stuknij, aby powiększyć lub pomniejszyć',
      hintText: 'Kliknij na obrazek, aby powiększyć',
      renderingError: 'Wystąpił błąd, wizualizacja nie jest dostępna dla wybranej konfiguracji.',
      webGLUnsupportedError: 'Wizualizacja nie jest dostępna ponieważ twoja przeglądarka nie obsługuje WebGL.',
    },
    tags: {
      clearResults: 'Wyczyść wszystko',
    },
  },
  catalogPage: {
    pageTitleFormat: 'Produkty',
    pageDescriptionFormat: 'Znajdź krzesło odpowiednie dla Ciebie',
    filterBar: {
      name: 'Filtry',
      results: 'Rezultaty: {results}',
    },
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Kod powinien mieć dokładnie {expectedLength} znaków.',
      codeInvalid: 'Podany kod {invalidCode} jest nieprawidłowy! Upewnij się, że został wpisany poprawnie.',
      codeNotFound: 'Nie jesteśmy w stanie znaleźć konfiguracji o kodzie {notFoundCode}.',
    },
    productFamily: {
      showMoreProducts: '*Zobacz więcej opcji',
    },
    searchForConfigurationText: 'Stworzyłeś własny projekt? Znajdź go tutaj',
    noResults: 'Nie znaleziono produktów pasujących do Twoich wyborów.',
    pagination: {
      title: 'Paginacja',
    },
  },
  disclaimer: {
    messagePart1: 'Prezentowane kolory mogą zależeć od ekranu Twojego urządzenia i jego ustawień. ',
    link: 'Skontaktuj się z nami',
    messagePart2: ' jeśli chesz uzyskać pomoc przy wyborze koloru.',
  },
  requestQuoteLink: {
    link: '*Buying for a company? Request a quote here.',
  },
  unauthorizedErrorPage: {
    pageDescriptionFormat: '*Description',
    pageTitleFormat: '*Unauthorized',
    title: '*Unauthorized',
    content: '*Access is allowed only for registered users.',
    buttonLink: '*Login',
  },
  forbiddenErrorPage: {
    pageDescriptionFormat:
      'Nie masz niezbędnych uprawnień, aby uzyskać dostęp do tej strony',
    pageTitleFormat:
      'Dostęp zabroniony',
    title:
      'O nie!',
    content1:
      'Nie masz niezbędnych uprawnień, aby uzyskać dostęp do tej strony. Możesz się ',
    logout:
      'wylogować',
    content2:
      ' i spróbować zalogować się na inne konto lub skontaktować się z pomocą techniczną',
    buttonLink:
      'Przejdź do strony głównej'
  },
  downloadsPage: {
    downloadList: {
      download: {
        downloadButton: 'Pobierz',
      },
      emptyScreen: {
        title: 'Nie znaleziono plików zgodnych z zaznaczonymi kryteriami wyszukiwania.',
        description:
          'Przepraszamy, wygląda na to, że nie posiadamy zasobów, których szukasz. Spróbuj ponownie, wybierając inne kryteria.',
      },
      results: 'Znaleziono {results} plików zgodnych z zaznaczonymi kryteriami wyszukiwania.',
      pagination: {
        title: 'Paginacja',
      },
    },
    filters: {
      title: 'Filtry',
      brandsFilter: {
        name: 'Popularne marki',
      },
      categoryFilter: {
        name: 'Kategoria',
        fileTypeFilter: {
          name: 'Format pliku',
        },
        resultsCounter: 'Wszystkie wyniki',
      },
      downloadAllButton: 'Pobierz wszystkie',
    },
    pageTitleFormat: 'Pliki do pobrania',
    pageDescriptionFormat:
      'Znajdź i pobierz pliki do pobrania, takie jak broszury informacyjne, obrazki, rysunki tenchniczne itp.',
  },
  readyMadeProductPage: {
    overviewSection: {
      name: 'Podsumowanie',
    },
    variationsSection: {
      name: 'Warianty',
    },
    specificationSection: {
      name: 'Specyfikacja',
    },
    productDetailsSection: {
      specificationSectionTitle: 'Specyfikacja',
      maintenanceSectionTitle: 'Pielęgnacja',
      downloadsSectionTitle: 'Pliki do pobrania',
      assetsDownloader: {
        downloadAllButton: 'Ściągnij wszystko',
        other: 'Pozostałe',
        categories: {},
      },
      productCare: {
        downloadGuide: 'Pobierz poradnik',
      },
    },
    productVariations: {
      addToCartButton: 'Dodaj do koszyka',
      buyButton: 'Kup teraz',
      deliveryTime: {
        deliveryTime: 'Czas dostawy',
        day: 'dzień',
        days: 'dni*',
        week: 'tydzień',
        weeks: 'tygodni*',
      },
      priceIncludingTax: 'Zawiera podatek i koszty dostawy',
      deliveryTimeAnnotation: '* W przypadku niektórych konfiguracji czas dostawy może być dłuższy',
      modelViewer: {
        hint: 'Kliknij na obrazku, aby powiększyć',
      },
      customizationSection: {
        textLine1: 'Szukasz czegoś innego?',
        textLine2: 'Możesz dodatkowo',
        linkText: 'spersonalizować to krzesło',
      },
      productOptions: {
        fabricInfo: {
          text: 'Informacje o materiale:',
          optionDescriptionModal,
        },
        fabricDescriptionCannotBeLoadedError:
          'Przepraszamy, coś poszło nie tak. Nie możemy pobrać informacji o tej tkaninie.',
      },
    },
    productCarousel: {
      title: 'Inni oglądali także',
    },
  },
};

export default translation;
